import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  // Re-checked on every navigation (not just once at bootstrap) so a token that expires
  // mid-session sends the user back to login instead of letting stale-looking state through.
  if (auth.hasValidSession()) return true;
  return router.createUrlTree(['/login']);
};

